module.exports = __webpack_public_path__ + "static/img/gaozhongwuli4.c4b9a6c1.jpg";